export class EqualHeight {
    /**
    * Create a tooltip for an inputfield
    * @param {HTMLElement} element Tooltip
    */
    constructor (element) {
        // Name, reference
        this.elements = Array.from(element.querySelectorAll('.product-link-spot'));
        
        // Properties
        let maxHeight = 0;

        // Calculations
        this.elements.forEach(item => {
            if(item.offsetHeight > maxHeight) {
                maxHeight = item.offsetHeight;
            }
        });

        //this.elements.forEach(item => item.style.minHeight = maxHeight + "px");
    }
}